import { environment } from 'src/environments/environment';

const apiUrl = environment?.apiUrl;

export const ESTAMP_CURLS = {
  stateList: `curl --location '${apiUrl}/bulk-estamp-api/state-list' \\
--header 'Accept: application/json' \\
--header 'x-api-key: besk_1767695831436_W2OXXXXXX'`,

  createOrder: `curl --location '${apiUrl}/bulk-estamp-api/order' \\
--header 'Content-Type: multipart/form-data' \\
--header 'x-api-key: besk_1767695831436_W2OXXXXXX' \\
--form 'stateId="6a08118819ea82d2daaxxxxx"' \\
--form 'denomination="500"' \\
--form 'purpose="Testing purpose"' \\
--form 'appendStampPosition="PRE"' \\
--form 'secondParty="ABC"' \\
--form 'file=@"/path/to/document.pdf"'`,

  orderList: `curl --location '${apiUrl}/bulk-estamp-api/client/orders?page=1&limit=10' \\
--header 'Accept: application/json' \\
--header 'x-api-key: besk_1767695831436_W2OXXXXXX'`,

  orderDetail: `curl --location '${apiUrl}/bulk-estamp-api/client/orders/{orderId}' \\
--header 'Accept: application/json' \\
--header 'x-api-key: besk_1767695831436_W2OXXXXXX'`,

  inventoryList: `curl --location '${apiUrl}/bulk-estamp-api/client/scanned-stamps?page=1&limit=10' \\
--header 'Accept: application/json' \\
--header 'x-api-key: besk_1767695831436_W2OXXXXXX'`,
};

export const ESIGN_CURLS = {
  sendDocument: `curl --location '${apiUrl}/documents-api/send' \\
--header 'Content-Type: multipart/form-data' \\
--header 'x-api-key: sk_1767695831436_W2OXXXXXX' \\
--form 'file=@"/C:/Users/Lenovo/Downloads/document.pdf"' \\
--form 'name="Loan Agreement - Rajesh Kumar"' \\
--form 'signers="[{\\\"name\\\":\\\"test\\\",\\\"email\\\":\\\"test@example.com\\\",\\\"phone\\\":\\\"9876543210\\\",\\\"esignType\\\":\\\"1\\\",\\\"signatureDetail\\\":[{\\\"page\\\":\\\"1\\\",\\\"coordinates\\\":[{\\\"x\\\":449,\\\"y\\\":273,\\\"w\\\":200,\\\"h\\\":100}]}]}]"' \\
--form 'signingOrder="sequential"' \\
--form 'livePhoto="true"' \\
--form 'message="Please sign this loan agreement document"'`,

  documentStatus: `curl --location '${apiUrl}/documents-api/{documentId}/status' \\
--header 'x-api-key: sk_1767695831436_W2OXXXXXX'`,

  downloadDocument: `curl --location '${apiUrl}/documents-api/{documentId}/download' \\
--header 'x-api-key: sk_1767695831436_W2OXXXXXX'`,

  allDocuments: `curl --location '${apiUrl}/documents-api?page=1&limit=10' \\
--header 'x-api-key: sk_1767695831436_W2OXXXXXX'`,

  documentById: `curl --location '${apiUrl}/documents-api/{documentId}' \\
--header 'x-api-key: sk_1767695831436_W2OXXXXXX'`,

  sendDocumentWithTemplate: `curl --location '${apiUrl}/documents-api/send/{templateId}' \\
--header 'Content-Type: application/json' \\
--header 'x-api-key: sk_1767695831436_W2OXXXXXX' \\
--form 'file=@"/C:/Users/Lenovo/Downloads/document.pdf"' \\
--form 'signers="[{\\\"name\\\":\\\"test\\\",\\\"email\\\":\\\"test@example.com\\\",\\\"phone\\\":\\\"9876543210\\\",\\\"esignType\\\":\\\"1\\\"}]"' \\
--form 'livePhoto="true"' \\
--form 'signingOrder="sequential"' \\`
};

const PAGINATION_QUERY = [
  { key: 'page', value: '1' },
  { key: 'limit', value: '10' }
];

export const ESTAMP_ENDPOINTS = [
  {
    title: '1. GET eSTAMP STATES LIST',
    description: 'Retrieves a list of all available Indian states for eStamp orders.',
    curl: ESTAMP_CURLS.stateList,
    notes: ['Use the stateId from this list when creating eStamp orders.'],
    postman: {
      method: 'GET',
      path: ['bulk-estamp-api', 'state-list'],
      query: [] as { key: string; value: string }[]
    }
  },
  {
    title: '2. CREATE eSTAMP ORDER',
    description: 'Creates an eStamp order with document details, party information, and document file.',
    curl: ESTAMP_CURLS.createOrder,
    notes: [
      'Replace stateId, denomination, second party, and the file path with your actual values.',
      'appendStampPosition accepts PRE or POST.'
    ],
    postman: {
      method: 'POST',
      path: ['bulk-estamp-api', 'order'],
      query: [] as { key: string; value: string }[],
      formdata: [
        { key: 'stateId', value: '6a08118819ea82d2daaxxxxx', type: 'text' },
        { key: 'denomination', value: '500', type: 'text' },
        { key: 'purpose', value: 'Testing purpose', type: 'text' },
        { key: 'appendStampPosition', value: 'PRE', type: 'text' },
        { key: 'secondParty', value: 'ABC', type: 'text' },
        { key: 'file', value: '', type: 'file', disabled: false }
      ]
    }
  },
  {
    title: '3. GET eSTAMP ORDERS LIST',
    description: 'Retrieves a paginated list of all eStamp orders.',
    curl: ESTAMP_CURLS.orderList,
    notes: ['Replace page and limit parameters to paginate through your eStamp orders.'],
    postman: {
      method: 'GET',
      path: ['bulk-estamp-api', 'client', 'orders'],
      query: PAGINATION_QUERY
    }
  },
  {
    title: '4. GET eSTAMP INVENTORY LIST',
    description: 'Retrieves a paginated list of scanned eStamp inventory available to your account.',
    curl: ESTAMP_CURLS.inventoryList,
    notes: ['Replace page and limit parameters to paginate through your eStamp inventory.'],
    postman: {
      method: 'GET',
      path: ['bulk-estamp-api', 'client', 'scanned-stamps'],
      query: PAGINATION_QUERY
    }
  },
  {
    title: '5. GET eSTAMP ORDER DETAILS',
    description: 'Fetches complete details of a specific eStamp order including status, payment information, and document details.',
    curl: ESTAMP_CURLS.orderDetail,
    notes: ['Replace orderId with your actual eStamp order ID.'],
    postman: {
      method: 'GET',
      path: ['bulk-estamp-api', 'client', 'orders', '{{orderId}}'],
      query: [] as { key: string; value: string }[]
    }
  }
];

export const ESIGN_ENDPOINTS = [
  {
    title: '1. SEND DOCUMENT VIA API',
    description: 'Uploads a document and sends it to one or more signers for electronic signature.',
    curl: ESIGN_CURLS.sendDocument,
    notes: [
      'esignType indicates the signing method — "1" for Aadhar, "2" for DSC, "3" for Aadhar Biometric.'
    ]
  },
  {
    title: '2. GET DOCUMENT STATUS',
    description: 'Fetch the current signing status of a document.',
    curl: ESIGN_CURLS.documentStatus,
    notes: ['Replace documentId with your actual document ID.']
  },
  {
    title: '3. DOCUMENT SIGNED DOWNLOAD',
    description: 'Downloads the final signed PDF document once signing is completed.',
    curl: ESIGN_CURLS.downloadDocument,
    notes: ['Replace documentId with your actual document ID.']
  },
  {
    title: '4. GET ALL DOCUMENTS',
    description: 'Retrieve a paginated list of all documents.',
    curl: ESIGN_CURLS.allDocuments,
    notes: []
  },
  {
    title: '5. GET DOCUMENT BY ID',
    description: 'Fetch complete details of a specific document.',
    curl: ESIGN_CURLS.documentById,
    notes: ['Replace documentId with your actual document ID.']
  },
  {
    title: '6. SEND DOCUMENT VIA TEMPLATE ID',
    description: 'Sends a predefined template (via templateId) to one or more signers for electronic signature.',
    curl: ESIGN_CURLS.sendDocumentWithTemplate,
    notes: [
      'Replace templateId with your actual template ID.',
      'esignType indicates the signing method — "1" for Aadhar, "2" for DSC, "3" for Aadhar Biometric.'
    ]
  }
];
